<template>
  <div>
    <div class="profile-header">
      <div class="avatar-and-name">
        <div class="avatar-wrap">
          <div
            class="camera-icon"
            @click="toggleCropperModal"
          >
            <ngc-icon
              name="camera"
              fill="#FFFFFF"
              size="medium"
            />
          </div>
          <div class="profile-avatar">
            <img
              v-if="user.profilePictureUrl"
              :src="user.profilePictureUrl"
              alt="Profile"
              class="profile-avatar-img"
            >
            <span
              v-else
              class="profile-avatar-initials"
            >{{ initials }}</span>
          </div>
        </div>
      </div>
    </div>
    <photo-uploader
      :value="uploaderVisible"
      :on-save="updateProfilePicture"
      @image="handleImageChange"
      @close="toggleCropperModal"
    />
  </div>
</template>

<script>
import photoUploader from './photoUploader'

export default {
  name: 'MyProfileHeader',
  components: {
    photoUploader
  },
  props: {
    user: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      uploaderVisible: false,
      newProfilePicture: {
        filename: '',
        image: null,
        data: null
      }
    }
  },
  computed: {
    initials () {
      return `${this.user.firstName[0] || ''}${this.user.lastName[0] || ''}`
    }
  },
  methods: {
    toggleCropperModal () {
      this.uploaderVisible = !this.uploaderVisible
    },
    updateProfilePicture () {
      this.$emit('update-profile-picture', this.newProfilePicture.data, this.newProfilePicture.filename)
    },
    handleImageChange ({ filename, dataURL }) {
      this.newProfilePicture.filename = filename
      this.newProfilePicture.image = dataURL
      this.newProfilePicture.data = dataURL.split(',', 2)[1]
    }
  }
}
</script>

<style scoped>

.profile-header {
  margin-bottom: 48px;
}

.avatar-and-name {
  display: flex;
  position: relative;
}

.avatar-wrap {
  position: relative;
  margin-right: 16px;
}

.profile-avatar {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #e4e7ec;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #475467;
  font-size: 28px;
  font-weight: 600;
  text-transform: uppercase;
}

.profile-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.camera-icon {
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  background-color: rgba(31, 31, 31, 0.8);
  border-radius: 50%;
  border: 2px solid white;
  height: 40px;
  width: 40px;
  left: 64px;
  top: 64px;
  cursor: pointer;
  z-index: 1;
}

</style>
